import { SDUIOnClickHandler } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { SDUIAvatarElementRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Avatar/SDUIAvatarElementRenderer";
import { SDUITileInstanceRendererProps } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/types";
import { Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import { ISDUIText } from "@faire/web-api--source/indigofair/data/ISDUIText";
import { VolumePricingBadge } from "@faire/retailer-visitor-shared/components/VolumePricing/VolumePricingBadge";

export const SDUIAvatarInfoCardTileRenderer = ({
  tileElement,
  loggingData,
}: SDUITileInstanceRendererProps) => {
  const { on_click } = tileElement;
  const { avatar, header_text, title, subtitle, badge_text } =
    tileElement.avatar_info_card_tile ?? {};

  return (
    <SDUIOnClickHandler
      onClickActions={on_click}
      loggingData={loggingData}
      logLegacyClickEvent
      className="flex relative p-4 border border-core-border-muted rounded-lg items-center gap-3 min-width-[327px] max-w-full md:p-5 md:gap-4"
    >
      <Column>
        {avatar ? (
          <SDUIAvatarElementRenderer
            className="not-first:ml-(--avatar-overlap-amount)"
            avatarElement={avatar}
            loggingData={loggingData}
          />
        ) : null}
      </Column>
      <Column gap="1/2x" className="flex-1 overflow-hidden">
        <Typography
          variant={{ mobileAndAbove: "paragraphSansMedium", tabletAndAbove: "subheadingSansMedium" }}
          truncate
          className="max-w-[85%]"
        >
          {getTextContent(header_text)}
        </Typography>
        <Typography
          variant={{ mobileAndAbove: "labelSansMedium", tabletAndAbove: "paragraphSansMedium" }}
          truncate
        >
          {getTextContent(title)}
        </Typography>
        <Typography
          variant={{ mobileAndAbove: "labelSansRegular", tabletAndAbove: "paragraphSansRegular" }}
          truncate
        >
          {getTextContent(subtitle)}
        </Typography>
      </Column>
      {badge_text?.style?.badge_message ? (
        <VolumePricingBadge
          discountString={badge_text.style.badge_message}
          className="[&&]:absolute top-0 right-4 md:right-5"
        />
      ) : null}
    </SDUIOnClickHandler>
  );
};

const getTextContent = (textElement?: ISDUIText) => {
  if (!textElement) {
    return undefined;
  }

  return textElement.slate_text_segments?.map(segment => segment.slate_text?.content ?? "").join("") ?? "";
};
